<template>
	<nav v-if="!keyboard.open" class="tabbar fixed inset-x-0 bottom-0 z-40 flex border-t border-line px-1.5" aria-label="Main">
		<a
			v-for="tab in tabs"
			:key="tab.key"
			:href="tab.root"
			class="relative flex min-h-tab flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-bold"
			:class="tab.key === activeTab ? 'text-ink' : 'text-muted'"
			:aria-current="tab.key === activeTab ? 'page' : undefined"
			@click.prevent="select(tab)"
		>
			<span class="flex h-[30px] w-14 items-center justify-center rounded-full" :class="{ 'bg-tint': tab.key === activeTab }">
				<Icon :name="tab.icon" />
			</span>
			<span>{{ tab.label }}</span>
			<span v-if="tab.key === 'bag' && bagCount" class="badge" :aria-label="`${bagCount} items`">{{ bagCount }}</span>
		</a>
	</nav>
</template>

<script>
import Icon from './Icon.vue'
import { keyboard } from '@/lib/keyboard'
import { TABS, lastPathForTab, markTabNavigation } from '@/lib/tabs'

export default {
	components: { Icon },
	inject: ['store'],
	data() {
		return { tabs: TABS, keyboard }
	},
	computed: {
		activeTab() {
			return this.$route.meta.tab
		},
		bagCount() {
			return this.store.cartTotalItems || 0
		},
	},
	methods: {
		select(tab) {
			if (tab.key !== this.activeTab) {
				markTabNavigation()
				this.$router.push(lastPathForTab(tab.key) || tab.root)
				return
			}
			// Tapping the current tab: first scroll to the top, then go back to the tab's first page.
			if (window.scrollY > 0) window.scrollTo({ top: 0, behavior: 'smooth' })
			else if (this.$route.path !== tab.root) this.$router.push(tab.root)
		},
	},
}
</script>

<style scoped>
.tabbar {
	padding-bottom: var(--safe-b);
	background: rgb(var(--bg) / var(--bar-alpha));
	-webkit-backdrop-filter: saturate(1.4) blur(16px);
	backdrop-filter: saturate(1.4) blur(16px);
}
.badge {
	position: absolute;
	top: 4px;
	left: 50%;
	margin-left: 4px;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	border-radius: 9px;
	background: rgb(var(--accent));
	color: rgb(var(--on-accent));
	font-size: 11px;
	font-weight: 800;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 0 2px rgb(var(--bg));
}
</style>
